import React from 'react';
import { Flex, Link } from 'theme-ui';
import ContentText from '@solid-ui-components/ContentText';
import WithDefaultContent from '@solid-ui-blocks/WithDefaultContent';
import Icon from '@solid-ui-components/ContentIcon/ContentIcon';
import styles from './styles';

const KnowledgeBaseArticleNav = ({ content: { text, collection } }) => (
  <Flex sx={styles.container}>
    <Link sx={styles.mainLink} href={'/'}>
      <Icon content={collection[1].icon} size='xxs' />
    </Link>
    <Icon content={collection[0].icon} size='xxxs' />
    <Link href={'/knowledge-base'} sx={styles.link}>
      Knowledge base
    </Link>
    <Icon content={collection[0].icon} size='xxxs' />
    <ContentText content={text} />
  </Flex>
);

export default WithDefaultContent(KnowledgeBaseArticleNav);
